
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/screen-time-laws-edtech-whole-class-tools-survive",
      function () {
        return require("private-next-pages/c/blog-posts/screen-time-laws-edtech-whole-class-tools-survive.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/screen-time-laws-edtech-whole-class-tools-survive"])
      });
    }
  